// extracted by mini-css-extract-plugin
export default {"html-content":"white-paper-module--html-content--aef6c","htmlContent":"white-paper-module--html-content--aef6c"};